export function endData (endData){//获取结束日期距离多少天
  var now = new Date();
  return (parseInt((new Date(endData).getTime() - new Date(now).getTime()) / (1000 * 60 * 60 * 24)))
  return (Math.abs(parseInt((new Date(endData).getTime() - new Date(now).getTime()) / (1000 * 60 * 60 * 24))))
}
export function zhongwen (zhongwen_){//中文校验
  if(zhongwen_ == ''){
    return '姓名不能为空哦'
  }
  if (!/^[\u4e00-\u9fa5]{0,}$/.test(zhongwen_))
    return '请输入中文';
  return false;
}
export function phone (phone_) {//校验手机号码
  if (!/^1[3456789]\d{9}$/.test(phone_))
    return '手机号码格式有误';
  return false;
}
export function integer (val) {
  if (!/^([1-9]\d*$|^[0]{1,1})$/.test(val))
    return '请输入0或正整数';
  return false;
}
export function nameFilters(name) {  //对名字进行过滤    张三（*三）  张某某（张*某）
 
  if (typeof(name) == "undefined") {
 
    return name;
 
  } else if (name.length < 2) {
 
    return name;
 
  } else if (name.length === 2) {
 
    return new Array(name.length).join("*") + name.substr(-1);
 
  } else {
 
    return (
 
      name.substr(0, 1) + new Array(name.length - 1).join("*") + name.substr(-1)
 
    );
 
  }
 
}
 
export function idCardFilters(num) {   //身份证进行过滤  429004199902024125（42900419********25）
  if (typeof(num) == "undefined") {
 
    return num;
 
  } else if (num.length != 18) {
 
    return num;
 
  } else {
 
    return num.replace(/(\d{8})\d{8}(\d*)/, "$1********$2");
 
  }
 
}
 
 
export function sexIdcareFilter(num) {   //根据身份证判断性别
 
  if (typeof(num) == "undefined") {
 
    return num;
 
  } else if (num.length != 18) {
 
    return num;
 
  } else {
 
    return num.substr(16, 1) % 2 === 1 ? "男" : "女";
 
  }
 
}
 
 
export function phoneFilters(num) {   //手机号码进行过滤  18641526389  （186****6389）
 
  if (typeof(num) == "undefined") {
 
    return num;
 
  } else if (num.length != 11) {
 
    return num;
 
  } else {
 
    return num.replace(/(\d{3})\d{4}(\d*)/, "$1****$2");
 
  }
 
}
 
 
export function textFilter(type, n) {   //文本超出后截取
 
    if (typeof(type) == 'undefined' || type.length <= n) {
 
        return type
 
    } else {
 
       if (type.length > n) {
 
           return type.substr(0, n) + '...'
 
        }
 
    }
 
}
 
export function priceFilter(type, n) {    //保留两位小数
 
	if (typeof(type) == 'undefined') {
 
		return type
 
	} else {
 
		return "￥" + type.toFixed(n)
 
   }
 
}
 
 
 
export function timeFilters(data) {   //时间
 
    var time = new Date(data);
 
    var year = time.getFullYear();//年
 
    var month = time.getMonth() + 1;//月
 
    var date = time.getDate();//日
 
    var hour = time.getHours();//时
 
    var minutes = time.getMinutes();//分
 
    var seconds = time.getSeconds();//秒
 
    return `${year}-${month}-${date} :${hour}:${minutes}:${seconds}`
 
}


// WEBPACK FOOTER //
// ./src/utils/filter.js